import Axios from 'axios';
import { EditageConfig } from 'config/onelogin.config';
import Cookies from 'js-cookie';
import { getEnv } from 'utils';
import https from 'https';
import { setAuthenticationCookie } from 'features/auth/utils';

const axios = Axios.create({
  baseURL: getEnv('MTG_URL_API'),
  httpsAgent: new https.Agent({
    // Only disable certificate validation in development
    rejectUnauthorized: process.env.APP_ENV !== 'development' ? true : false,
  }),
});

const oneloginApiService = axios.create({
  baseURL: EditageConfig.sso.federatedDomain,
});

oneloginApiService.interceptors.request.use(async (config) => {
  config.withCredentials = true;
  return config;
});

axios.interceptors.request.use(async (config) => {
  if (typeof window !== 'undefined') {
    const cookieKey = EditageConfig.cookies.idCookieKey;
    const userCookie = Cookies.get(cookieKey);

    if (userCookie) {
      config.headers.Authorization = `Bearer ${userCookie}`;
    }
  }

  return config;
});

// Response interceptor
axios.interceptors.response.use(
  // Success handler
  (response) => {
    return response;
  },
  // Error handler
  async function (error) {
    if (error.response) {
      // Handle specific status codes
      if (error.response.status === 401) {
        let response;
        let retryCount = 0;
        const maxRetries = 2;
        const originalRequest = error.config;
        // window.location.reload();
        if (typeof window !== 'undefined') {
          window.location.href = '/auth/logout';
        }
        // console.log('Unauthorized request, attempting to refresh token...');
        return Promise.reject(null);

        // while (retryCount < maxRetries) {
        //   try {
        //     response = await oneloginApiService.get('/oauth/token');
        //     break;
        //   } catch (tokenError) {
        //     retryCount++;
        //     if (retryCount >= maxRetries) {
        //       // Logout logic: clear cookies and reload or redirect
        //       // or redirect to login page
        //     }
        //   }
        // }

        // if (response) {
        //   // Retry the original request with new token
        //   const auid = Cookies.get(EditageConfig.cookies.auidCookieKey);
        //   const composedToken = `${response.data.access_token}|${auid}`;
        //   setAuthenticationCookie(composedToken);
        //   originalRequest.headers.Authorization = `Bearer ${composedToken}`;
        //   return axios(originalRequest);
        // }
      }
    } else if (error.request) {
      console.error('Request error, no response received');
    } else {
      console.error('Error setting up request:', error.message);
    }

    // You can return a custom error object or rethrow the error
    return Promise.reject(error);
  },
);

export default axios;
